import React from "react";

function DbmsPage() {
  return <h1>DBMS Notes</h1>;
}

export default DbmsPage;